import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FaTrash as DeleteIcon,
  FaExclamationCircle as ExclamationIcon,
} from 'react-icons/fa';
import Button from '../../app/buttons';
import { destroyMedium } from '../actions';
import { Message, ButtonWrap, Title } from './styled';
import { singularize } from 'inflected';

// Shown when the file reached us but we could not make something usable out of it.
//
// `recoverable` distinguishes "still being processed and carrying an error from an
// earlier attempt" from "processing has finished and failed". The wording matters
// because in BOTH cases the original file is safely in storage -- so telling
// someone their upload failed, which is what used to happen here, is wrong and
// leads them to delete a file that is fine.
//
// COPY IS PLACEHOLDER -- see docs/upload_reliability_for_design.md. The behaviour
// is the point of this change; Natalie owns the words.
const Processing = ({
  id, pageId, mediumType, storyId, recoverable, ...props
}) => (
  <Message>
    <Title>
      <ExclamationIcon size="24" />
      <span>
        {recoverable ? 'Still Processing' : "Couldn't Prepare This " + singularize(mediumType).replace(/^./, c => c.toUpperCase())}
      </span>
    </Title>
    <p>
      {recoverable
        ? `This ${singularize(mediumType).toLowerCase()} is taking longer than expected. It is saved — check back shortly.`
        : `Your ${singularize(mediumType).toLowerCase()} uploaded and is saved, but we couldn't prepare it for your book. Deleting and re-adding it sometimes helps.`}
    </p>
    <ButtonWrap>
      <Button
        onClick={() => (props.destroyMedium(
          id,
          pageId,
          mediumType,
          storyId,
        ))}
        destructive
      >
        <DeleteIcon
          color="white"
          size="24"
        />
        Delete
      </Button>
    </ButtonWrap>
  </Message>
);

Processing.propTypes = {
  id: PropTypes.string.isRequired,
  mediumType: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
  storyId: PropTypes.string.isRequired,
  destroyMedium: PropTypes.func.isRequired,
  recoverable: PropTypes.bool,
};

Processing.defaultProps = {
  recoverable: false,
};

export default connect(
  null,
  { destroyMedium },
)(Processing);
